import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function NoSearchResultsIcon({
  className,
  stroke = IconColors.DarkGrey,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon className={className} height="24" viewBoxDimensions="0 0 24 24" width="24">
      <path
        d="M17.687447916666667 9.194661666666667A8.492786250000002 8.492786250000002 0 1 1 9.19559875 0.7028125000000001a8.491849166666666 8.491849166666666 0 0 1 8.491849166666666 8.491849166666666Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.50"
      ></path>
      <path
        d="m6.154763333333333 6.154763333333333 5.963598333333334 5.963598333333334"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.50"
      ></path>
      <path
        d="m6.154763333333333 12.118361666666667 5.963598333333334 -5.963598333333334"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.50"
      ></path>
      <path
        d="m15.20042875 15.199491666666667 6.58675875 6.587695833333334"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.50"
      ></path>
    </SimpleIcon>
  );
}
